import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGlobalConfig } from '../redux/configuration/action';
import { RootState } from '../redux/root-reducer';
import {
    activeInfluencerTiersSelector,
    campaignPlatformsSelector,
    effectiveOperatingCountryCodeSelector,
    ugcBudgetConfigSelector,
    ugcCampaignFeeConfigSelector,
} from '../selectors/selectors';

/**
 * Loads country-scoped global configuration for the brand dashboard (UGC tiers, platforms, budget rules).
 * Call from `BrandDashboardLayout` so all brand routes have config before campaign creation.
 */
export function useBrandGlobalConfiguration() {
    const dispatch = useDispatch();
    const countryCode = useSelector(effectiveOperatingCountryCodeSelector);
    const fetchingGlobalConfig = useSelector((state: RootState) => state.configuration.fetchingGlobalConfig);
    const globalConfiguration = useSelector((state: RootState) => state.configuration.globalConfiguration);
    const activeTiers = useSelector(activeInfluencerTiersSelector);
    const campaignPlatforms = useSelector(campaignPlatformsSelector);
    const ugcBudget = useSelector(ugcBudgetConfigSelector);
    const ugcFeeConfig = useSelector(ugcCampaignFeeConfigSelector);

    useEffect(() => {
        dispatch(getGlobalConfig(countryCode));
    }, [dispatch, countryCode]);

    const isReady = Boolean(globalConfiguration) && !fetchingGlobalConfig;

    return {
        countryCode,
        fetchingGlobalConfig,
        isReady,
        globalConfiguration,
        activeTiers,
        campaignPlatforms,
        ugcBudget,
        ugcFeeConfig,
    };
}
